<template>
  <supplier-po-wo :poStillOpen="true" />
</template>

<script>
export default {
  name: 'SupplierPoWoClose',
  components: {
    'supplier-po-wo': () => import(/* webpackChunkName: 'RFQSupplierPoWo' */ '@/components/Shared/RFQSupplierPoWo')
  }
}
</script>
